// extracted by mini-css-extract-plugin
module.exports = {"component":"SuggestAreaSelection_component__2mGdX","wrapper":"SuggestAreaSelection_wrapper__2ca0L","text":"SuggestAreaSelection_text__2eftm"};